/* eslint-disable jsx-a11y/alt-text */
import ImagesUrl from "#constants/images.js";
import { AdminRoutePath } from "#routes/routePath.jsx";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SplashScreen = () => {
  const nav = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      nav(AdminRoutePath.LOGIN.path);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="splash-main-wrapper">
      <div className="splash-inner-container">
        <div className="splash-inner-imgBlk">
          <img src={ImagesUrl.splash} about="splash-icon" />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
